import React, { useState, useEffect, useMemo } from "react";
import {
  Box,
  Grid,
  Typography,
  IconButton,
  Button,
  Pagination,
} from "@mui/material";
import { Edit, Delete, Visibility } from "@mui/icons-material";
import { withApiContext, withUserContext,withWindowContext } from "context";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { Breadcrumb } from "components";
import { useTheme } from "styled-components";
import RubricsSearch from "./RubricsSearch";
import RubricsModal from "./RubricsModal";
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch'

const Rubrics = ({ history, ctx_api, ctx_labels, ctx_user, ctx_window = window, ...props }) => {
  const theme = useTheme();

  const [rubrics, setRubrics] = useState([]);
  const [searchResult, setSearchResult] = useState(null);
  const [isSearching, setIsSearching] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const [page, setPage] = useState(1);
  const itemsPerPage = 8;

  const handleCreateRubric = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const subjects = ctx_user?.user?.campusSubj || [];
  const standards = ctx_user?.user?.campusCategories || [];

  useEffect(() => {
    // setRubrics(data);
    fetchRubrics();
  }, []);

  const fetchRubrics = async () => {
    try {
      const { rsp } = await ctx_api.privateRequest({
        cmd: "get_all_rubrics",
        args: {
          memberId: ctx_user.user.id,
          organizationId: ctx_user.user.organizationId,
          goiId: ctx_user.user.goiId,
        },
      });
      console.log(rsp,"rsp");
      

      const data = rsp.map((item) => {
       // find subject label
       const subjectObj = subjects.find(sub => sub.value == item.curriculum_id || "");
       const subjectLabel = subjectObj?.label || "N/A";

       // find standard label
       const standardObj = standards.find(std => std.value == item.category_id || "");
       const standardLabel = standardObj?.label || "N/A";
        return{
        id: item.rubrics_assessment_id ?? item.rubrics_id ?? item.id,
        name: item.name,
        description: item.description || "",
        curriculumId: item.curriculum_id || "",
        categoryId:item.category_id || "",
        subject: subjectLabel,
        standard: standardLabel,
        createdBy:item.createdby || "N/A",
        canDelete: item.can_delete !== false,
      }});
       console.log(data,"here your data");
       
      setRubrics(data);
    } catch (error) {
      console.error("Error fetching rubrics types:", error);
      setRubrics([]);
    }
  };


const handleDeleteRubric = async (rubric) => {
 ctx_window?.confirm({
      message: `Are you sure you want to delete "${rubric.name}"?`,
      yesText: "Delete",
      noText: "Cancel",
      callback: async (confirmed) => {
        if (confirmed) {

  try {
    const response = await ctx_api.privateRequest({
      cmd: "delete_rubrics",
       args: { rubrics_assessment_id: rubric.id },
    });

    const rsp = response?.rsp || response;

    if (rsp.StatusValue === 1) {
      setRubrics(prev => prev.filter(r => r.id !== rubric.id));
    } else {
      ctx_window?.alert(response.StatusText || "Unable to delete rubric");
    }
  } catch (err) {
    ctx_window?.alert("Delete rubric failed:", err);
    console.error(err);
  }
   }
      },
    });
};


  const handleSearchResult = (result) => {
    setIsSearching(false);
    setSearchResult(result);
    setPage(1);
  };

  const clearSearch = () => {
    setSearchResult(null);
  };

  const handleViewRubric = (rubric) => {
    const alternateEntry = {
      id: rubric.id,
      testId: rubric.id,
      name: rubric.name,
      standard: rubric.standard,
      subject: rubric.subject,
    };

    history.push({
      pathname: "/publish-rubrics",
      state: {
        rubric,
        action: "add",
        alternateEntry,
        entity: alternateEntry,
        fromClassViewer: false,
        isCreation: true
      },
    });
  };

  const handleOpenAssessment = (rubric) => {
    if (!rubric?.id) {
      ctx_window?.alert?.("Assessment id missing for this rubric.");
      return;
    }
    history.push({
      pathname: "/Rubrics-assessment",
      state: {
        assessmentId: rubric.id,
        assessment_id: rubric.id,
        assessmentName: rubric.name,
      },
    });
  };

  const renderCard = (rubric) => (
    <Box
      key={rubric.id}
      sx={{
        all: "unset",
        position: "relative",
        p: 2,
        borderRadius: "12px",
        backgroundColor: "#F4EFFF",
        height: 200,
        minHeight: 200,
        maxHeight: 200,
        width: "100%",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.1)",
        transition: "transform 0.2s ease, box-shadow 0.2s ease",
        "&:hover": {
          transform: "translateY(-5px)",
          boxShadow: "0px 4px 10px rgba(0,0,0,0.15)",
        },
        "&::after": {
          content: '""',
          position: "absolute",
          top: 0,
          right: 0,
          width: 50,
          height: 50,
          borderTopRightRadius: "12px",
          borderBottomLeftRadius: "50px",
          backgroundColor: theme.color4,
        },
        cursor: "pointer",
      }}
      
    >
      <Box>
        <Typography variant="h6" sx={{ fontWeight: 600, color: "#1A1A1A", mb: 0.5 }}>
          {rubric.name}
        </Typography>
        <Typography variant="body2" sx={{ color: "#5E5E5E", mb: 0.5 }}>
          {rubric.subject}
        </Typography>
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          {rubric.standard}
        </Typography>
      </Box>

      <Box>
        <Typography variant="body2" sx={{ color: "#333" }}>
          {rubric.createdBy}
        </Typography>
        {/* <Typography variant="body2" sx={{ color: "#333" }}>
          Start Date
        </Typography>
        <Typography variant="caption" sx={{ color: "#555" }}>
          {rubric.startDate}
        </Typography> */}
      </Box>

      <Box display="flex" justifyContent="flex-end" gap={1}>
        <IconButton
          size="small"
          sx={{ color: "#4B0082" }}
          onClick={(event) => {
            handleOpenAssessment(rubric)
            event.stopPropagation();
            // future edit handler can go here
          }}
          
        >
          <Edit fontSize="small" />
        </IconButton>
        <IconButton
          size="small"
          sx={{ color: "#4B0082" }}
          onClick={() => {
                  handleDeleteRubric(rubric)}}
        >
          <Delete fontSize="small" />
        </IconButton>
        <IconButton
          size="small"
          sx={{ color: "#4B0082" }}
          onClick={(event) => {
            event.stopPropagation();
            handleViewRubric(rubric);
          }}
        >
          <RocketLaunchIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );

  const visibleRubrics = useMemo(() => {
    if (searchResult && Array.isArray(searchResult)) return searchResult;
    return rubrics;
  }, [rubrics, searchResult]);

  const pageCount = Math.ceil(visibleRubrics.length / itemsPerPage);

  const paginatedRubrics = useMemo(() => {
    const start = (page - 1) * itemsPerPage;
    const end = start + itemsPerPage;
    return visibleRubrics.slice(start, end);
  }, [page, visibleRubrics]);

  const handleChangePage = (event, value) => {
    setPage(value);
  };

  return (
    <Box sx={{ p: 2 }}>
      <Box
        sx={{
          mb: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        <Breadcrumb
          list={[
            { title: "Rubrics", current: true },
          ]}
        />
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
              alignItems: "flex-end",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={handleCreateRubric}
              sx={{ color: "#fff", textTransform: "none" }}
            >
              Create Rubrics
            </Button>
            <RubricsSearch onSearchResult={handleSearchResult} rubrics={rubrics} />
          </Box>
        </Box>
      </Box>

      {/* Cards */}
      <Grid
        container
        spacing={2}
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: "20px",
          justifyContent: "center",
        }}
      >
        {paginatedRubrics.length > 0 ? (
          paginatedRubrics.map((rubric, index) => (
            <Grid item key={index}>
              {renderCard(rubric)}
            </Grid>
          ))
        ) : (
          <Box sx={{ textAlign: "center", py: 4, gridColumn: "1 / -1" }}>
            <Typography>No rubrics found.</Typography>
          </Box>
        )}
      </Grid>

      {/* Pagination */}
      {pageCount > 1 && (
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
          <Pagination
            count={pageCount}
            page={page}
            onChange={handleChangePage}
            color="primary"
          />
        </Box>
      )}

      <RubricsModal
        open={openModal}
        onClose={handleCloseModal}
        ctx_user={ctx_user}
        ctx_api={ctx_api}
        ctx_window={ctx_window}
      />
    </Box>
  );
};

export default withApiContext(withUserContext(withRouter(withWindowContext(Rubrics))));
